import { useClientPortalSelector, selectBooking } from "../../../../redux";
import { useClientPortalConfigContext } from "context/ClientPortalConfig.ctx";
import { amountToCurrency } from "utils/localeHelper";
import { getTimeZoneAbbreviation } from "utils/timeZoneUtils";

export const getContentValue = (completedValue: string | undefined, currentValue: string | undefined): string => {
    return completedValue || currentValue || "Not selected";
};

export const getAmountValue = (completedValue: number | undefined, currentValue: number | undefined): number | null => {
    if (completedValue > 0) {
        return completedValue;
    }

    if (currentValue > 0) {
        return currentValue;
    }

    return null;
};

export const useSessionBookingData = () => {
    const { location, service, provider, group, availability, session, confirmation } =
        useClientPortalSelector(selectBooking);

    const {
        clientPortalConfig: { currencySymbol },
    } = useClientPortalConfigContext();

    const completedData = session.completedBookingData;

    const locationContent = getContentValue(completedData?.location?.locationName, location.data?.locationName);
    const serviceNameContent = getContentValue(completedData?.service?.serviceName, service.data?.serviceName);
    const groupContent = getContentValue(completedData?.group?.groupName, group.data?.groupName);
    const providerContent = getContentValue(completedData?.provider?.providerName, provider.data?.providerName);
    const whenContent = getContentValue(completedData?.availability?.displayText, availability.data?.displayText);
    const whenTimeZoneContent = getTimeZoneAbbreviation(
        completedData?.availability?.timeEntry?.dateTimeOffset ?? availability.data?.timeEntry?.dateTimeOffset
    );
    const clientContent = getContentValue(completedData?.confirmation?.client?.name, confirmation.data?.client?.name);

    const rawServicePrice = getAmountValue(completedData?.service?.amount, service.data?.amount);

    return {
        locationContent,
        serviceNameContent,
        groupContent,
        providerContent,
        whenContent,
        whenTimeZoneContent,
        clientContent,
        rawServicePrice,
        servicePriceContent: rawServicePrice ? amountToCurrency(rawServicePrice, currencySymbol) : null,
    };
};
